import api from "../api/api";

export interface QuotaResponse {
  client_used: number;
  client_limit: number;
  client_remaining: number | null;
  user_used: number;
  user_limit: number;
  user_remaining: number | null;
}

export interface UsageLog {
  id: number;
  user: number;
  action: string;
  file_size_mb: number;
  metadata: any;
  created_at: string;
  username: string;
}

export async function handleGetQuota(
  userId: string,
  access_token: string
): Promise<QuotaResponse> {
  try {
    const response = await api.get<QuotaResponse>(`/api/v1/users/my-quota/`, {
      headers: { Authorization: `Bearer ${access_token}` },
    });
    return response.data;
  } catch (error: any) {
    console.error("Error fetching quota:", error.response?.data || error.message);
    throw error;
  }
}

export async function handleGetMyUsage(
  access_token: string
): Promise<{ data: UsageLog[], total: number }> {
  try {
    const response = await api.get<any>(`/api/v1/subscriptions/my-usage/`, {
      headers: { Authorization: `Bearer ${access_token}` },
    });

    const data = response.data.results || response.data.data || [];
    const total = response.data.count || response.data.total || data.length;

    return {
      data: data,
      total: total
    };
  } catch (error: any) {
    console.error("Error fetching usage:", error.response?.data || error.message);
    throw error;
  }
}
